import { PlatformDeclineType } from '../enum/platform-decline-type.enum';

export const platformDeclineTypeConstant: { [key in PlatformDeclineType]: string } = {
  [PlatformDeclineType.VIOLATES_POLICY]: 'Нарушение политики канала',
  [PlatformDeclineType.INCOMPLETE_INFORMATION]: 'Неполная информация',
  [PlatformDeclineType.OTHER]: 'Другое',
};
